<template>
  <v-dialog v-model="internalShow" max-width="500px">
    <v-card>
      <v-card-title class="headline primary white--text pa-3">
        {{ isMulti ? `Kết xuất ${totalCount} dữ liệu` : 'Kết xuất dữ liệu' }}
        <v-spacer></v-spacer>
        <v-btn icon dark @click="internalShow = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-tabs v-if="!isMulti" v-model="tab" background-color="grey lighten-4" grow>
        <v-tab>Xuất Dữ Liệu</v-tab>
        <v-tab>Xuất Hình Ảnh</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <!-- Tab Xuất Dữ liệu -->
        <v-tab-item>
          <v-card flat>
            <v-card-text class="pt-4">
              <div v-if="!isMulti && availableFields.length > 0">
                <div class="subtitle-2 mb-2">Chọn trường dữ liệu cần kết xuất:</div>
                <v-sheet class="overflow-y-auto mb-4" max-height="200"
                  style="border: 1px solid #e0e0e0; border-radius: 4px;">
                  <v-list dense>
                    <v-list-item v-for="(field, index) in availableFields" :key="index">
                      <v-list-item-action>
                        <v-checkbox v-model="selectedFields" :value="field.code" hide-details dense
                          color="primary"></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{ field.name }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-sheet>
              </div>

              <div v-if="isMulti && fields.length === 0" class="mb-3">
                <v-alert type="info" text dense class="mb-2 text-caption">
                  Bạn đang tìm kiếm trên <strong>Tất cả các lớp</strong>. Nếu xuất Excel, hệ thống sẽ tự động tạo nhiều
                  Sheet, mỗi Sheet chứa <strong>toàn bộ thuộc tính chi tiết</strong> của một Lớp dữ liệu.
                  Để tùy chọn từng trường thuộc tính riêng, vui lòng chọn 1 lớp cụ thể ở ô tìm kiếm.
                </v-alert>
              </div>

              <div v-if="isMulti" class="subtitle-2 mb-3 grey--text text--darken-2">
                Tổng số bản ghi sẽ xuất: <strong>{{ totalCount }}</strong> kết quả.
              </div>

              <v-select v-model="dataFormat" :items="dataFormats" label="Định dạng file" outlined dense
                hide-details></v-select>
            </v-card-text>
            <v-card-actions class="px-4 pb-4">
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="exportData" :loading="exporting"
                :disabled="selectedFields.length === 0 && availableFields.length > 0">
                <v-icon left>mdi-file-download</v-icon> Tải Xuống
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>

        <!-- Tab Xuất Hình ảnh -->
        <v-tab-item v-if="!isMulti">
          <v-card flat>
            <v-card-text class="pt-4">
              <div class="subtitle-2 mb-2">Ảnh xem trước (Đã cố định vị trí):</div>
              <div v-if="previewImage"
                style="border: 1px solid #ccc; border-radius: 4px; overflow: hidden; height: 180px; display: flex; align-items: center; justify-content: center; background: #f5f5f5;"
                class="mb-4">
                <img :src="previewImage" style="max-width: 100%; max-height: 100%; object-fit: contain;" />
              </div>
              <div v-else class="mb-4 text-center grey--text">
                Không thể tải ảnh xem trước
              </div>
              <div class="subtitle-2 mb-2">Định dạng ảnh:</div>
              <v-select v-model="imageFormat" :items="imageFormats" label="Định dạng kết xuất" outlined dense
                hide-details class="mb-4"></v-select>
            </v-card-text>
            <v-card-actions class="px-4 pb-4">
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="exportImage" :disabled="!previewImage">
                <v-icon left>mdi-image-outline</v-icon> Tải Ảnh Xuống
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import * as Papa from 'papaparse'
import { API_MAP_SEARCH } from '@api'

export default {
  name: 'ExportFeatureDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Array,
      default: () => [],
    },
    featureData: {
      type: Object,
      default: () => ({}),
    },
    previewImage: {
      type: String,
      default: null
    },
    isMulti: {
      type: Boolean,
      default: false
    },
    searchPayload: {
      type: Object,
      default: () => ({})
    },
    totalCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tab: 0,
      selectedFields: [],
      dataFormat: 'xlsx',
      dataFormats: [
        { text: 'Excel (.xlsx)', value: 'xlsx' },
        { text: 'CSV (.csv)', value: 'csv' },
        { text: 'JSON (.json)', value: 'json' },
        { text: 'GeoJSON (.geojson)', value: 'geojson' },
      ],
      imageFormat: 'png',
      imageFormats: [
        { text: 'PNG Image (.png)', value: 'png' },
        { text: 'JPG Image (.jpg)', value: 'jpeg' },
      ],
      exporting: false
    }
  },
  computed: {
    internalShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
    availableFields() {
      return this.fields.filter(f => {
        if (!f || !f.code) return false
        if (f.type === 'geometry') return false
        if (f.visibility && (f.visibility.browse === false || f.visibility.read === false)) return false
        return true
      })
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.selectedFields = this.availableFields.map(f => f.code)
      }
    },
    fields: {
      immediate: true,
      handler() {
        this.selectedFields = this.availableFields.map(f => f.code)
      }
    }
  },
  methods: {
    async exportData() {
      if (this.isMulti) {
        this.exporting = true
        try {
          const payload = {
            ...this.searchPayload,
            format: this.dataFormat,
            selected_fields: this.selectedFields
          }
          const res = await API_MAP_SEARCH.exportSearch(payload)

          let fileName = `KetQuaTraCuu_${new Date().getTime()}.${this.dataFormat}`
          const disposition = res.headers && res.headers['content-disposition']
          if (disposition && disposition.indexOf('filename=') !== -1) {
            const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition)
            if (matches != null && matches[1]) {
              fileName = matches[1].replace(/['"]/g, '')
            }
          }

          saveAs(new Blob([res.data]), fileName)

          this.$store.dispatch('notify/success', { message: "Tải dữ liệu thành công!" })
          this.internalShow = false
        } catch (err) {
          if (err.response && err.response.data instanceof Blob) {
            const text = await err.response.data.text()
            try {
              const json = JSON.parse(text)
              this.$store.dispatch('notify/error', { message: json.message || "Không thể xuất file" })
            } catch (e) {
              this.$store.dispatch('notify/error', { message: "Lỗi xuất file từ hệ thống" })
            }
          } else {
            this.$store.dispatch('notify/error', { message: "Lỗi kết nối khi tải file" })
          }
        } finally {
          this.exporting = false
        }
        return
      }

      // Single feature export mode
      const rowData = {}
      this.selectedFields.forEach(code => {
        const fieldObj = this.availableFields.find(f => f.code === code)
        if (fieldObj) {
          const val = this.featureData[code]
          rowData[fieldObj.name] = (val !== null && val !== undefined) ? val : ''
        }
      })

      const dataArray = [rowData]
      const fileName = `KetQuaTraCuu_${new Date().getTime()}`

      if (this.dataFormat === 'xlsx') {
        const ws = XLSX.utils.json_to_sheet(dataArray)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1")
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${fileName}.xlsx`)
      }
      else if (this.dataFormat === 'csv') {
        const csvContent = Papa.unparse(dataArray)
        const blob = new Blob(["\ufeff" + csvContent], { type: 'text/csv;charset=utf-8;' })
        saveAs(blob, `${fileName}.csv`)
      }
      else if (this.dataFormat === 'json') {
        const jsonContent = JSON.stringify(rowData, null, 2)
        const blob = new Blob([jsonContent], { type: 'application/json' })
        saveAs(blob, `${fileName}.json`)
      }
      else if (this.dataFormat === 'geojson') {
        const geom = this.featureData.geometry || (this.featureData.feature && this.featureData.feature.geometry) || null
        const geojson = {
          type: "Feature",
          properties: rowData,
          geometry: geom
        }
        const geojsonContent = JSON.stringify(geojson, null, 2)
        const blob = new Blob([geojsonContent], { type: 'application/geo+json' })
        saveAs(blob, `${fileName}.geojson`)
      }

      this.internalShow = false
    },
    exportImage() {
      if (!this.previewImage) return;

      if (this.imageFormat === 'jpeg') {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.fillStyle = "#FFFFFF";
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0);
          const jpegDataUrl = canvas.toDataURL("image/jpeg");
          this.triggerDownload(jpegDataUrl, "jpg");
        };
        img.src = this.previewImage;
      } else {
        this.triggerDownload(this.previewImage, "png");
      }
    },
    triggerDownload(dataUrl, ext) {
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = `BanDoTraCuu_${new Date().getTime()}.${ext}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.internalShow = false;
    }
  }
}
</script>

<style scoped></style>
